import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { KPI } from '../../../@core/api';
import { ChartFiltersService } from '../../../@core/utils';

import { FormsModule } from '@angular/forms';
import { NbRadioModule } from '@nebular/theme';

@Component({
    selector: 'app-energy-or-carbon-trajectory-filter',
    templateUrl: './energy-or-carbon-trajectory-filter.component.html',
    styleUrls: ['./energy-or-carbon-trajectory-filter.component.scss'],
    standalone: true,
    imports: [NbRadioModule, FormsModule, TranslateModule]
})
export class EnergyOrCarbonTrajectoryFilterComponent implements OnInit, OnDestroy {

  public options = [
    {
      value: KPI.EnergyOrCarbonTrajectoryFilter.ENERGY,
      label: this.translate.instant('Ratio')
        +  ' '
        + this.translate.instant('kWh / m²'),
    },
    {
      value: KPI.EnergyOrCarbonTrajectoryFilter.CARBON,
      label: this.translate.instant('Ratio')
        +  ' '
        + this.translate.instant('kg_co2e_m2_sub'),
    },
  ];
  public filterValue: number;

  private subscriptions: Subscription[] = [];

  constructor(
    private chartFiltersService: ChartFiltersService,
    private translate: TranslateService,
  ) {
  }

  public ngOnInit(): void {
    this.subscriptions.push(
      this.chartFiltersService.filter$('energyOrCarbonTrajectory').pipe(
        first()
      ).subscribe((filterValue) =>
        this.filterValue = <number>filterValue
      ),
    );
  }

  public filterValueChanged(): void {
    setTimeout(() => {
      this.chartFiltersService.setFilter('energyOrCarbonTrajectory', this.filterValue);
    }, 50);
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

}
